import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkRemoveCarePlanMedicalNote } from '../types';

const onRemoveCarePlanMedicalNote: IThunkRemoveCarePlanMedicalNote = thunk(
  // @ts-ignore
  async ({ removeCarePlanMedicalNote }, id) => {
    await api.carePlanMedicalNotes.remove(id);
    removeCarePlanMedicalNote(id);
  },
);

export default onRemoveCarePlanMedicalNote;
